import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { ClaimService, ErrorStateService, GlobalConstants, GuidService, LoggingService } from '@app-core';
import { Claim } from '@app-models';
import { catchError, Observable, of, tap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ClaimResolverParent implements Resolve<Claim | null> {
    private readonly claimService: ClaimService = inject(ClaimService);
    private readonly errorStateService: ErrorStateService = inject(ErrorStateService);
    private readonly router: Router = inject(Router);
    private readonly guidService: GuidService = inject(GuidService);
    private readonly claimStatus = GlobalConstants.CLAIM_STATUS;

    constructor() {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Claim | null> {
        const GUID = route.queryParamMap.get('guid');
        LoggingService.log('ClaimResolverParent::resolve:', GUID);

        if (this.errorStateService.hasProgressEventErrorOccurred()) {
            // If a progress event error occurred, navigate to the error page and return null
            this.router.navigate(['/error'], { skipLocationChange: true });
            return of(null);
        } else if (!GUID) {
            this.router.navigate(['/not-found'], { skipLocationChange: true });
            return of(null);
        }
        // Set the GUID in the GuidService for later use
        this.guidService.setGuid(GUID);
        //return claim;
        return this.claimService.getClaim(GUID).pipe(
            tap((claim) => {
                // Intervene if the claim status is pending physician, allow the parent to reach the success screen
                // where they can get the physician form or email it to the physician
                if (claim && claim.claimStatusId === this.claimStatus.PENDING_PHYSICIAN.id) {
                    this.claimService.setSubmissionSuccessful(true);
                    this.router.navigate(['/success-medical'], { skipLocationChange: true });
                }
                if (claim && claim.claimStatusId === this.claimStatus.PENDING_EMPLOYER.id) {
                    this.claimService.setSubmissionSuccessful(true);
                    this.router.navigate(['/success-employer'], { skipLocationChange: true });
                }
            }),
            catchError((err) => {
                // Handle errors, redirect if needed
                this.router.navigate(['/error'], { skipLocationChange: true });
                return of(null);
            }),
        );
    }
}
